import { BlocksIcon, ConvertFileIcon, SmartResizeIcon } from '@air/next-icons';

export type CanvasSuggestion = {
  icon: typeof ConvertFileIcon;
  label: string;
  message: string;
};

export const BUILD_CAMPAIGN_SUGGESTION: CanvasSuggestion = {
  icon: BlocksIcon,
  label: 'Build a campaign set',
  message:
    'Create a social campaign with 3 minimal, zen-focused variations for Instagram (feed and stories) and print (11x8.5" landscape, 300 DPI). Copy should be short, calm, meditative phrases. Each piece stands alone. Keep the gradient background seamless and the image content centered. Give me a few headline options to choose from first.',
};

export const SMART_RESIZE_SUGGESTION: CanvasSuggestion = {
  icon: SmartResizeIcon,
  label: 'Smart resize for socials',
  message:
    'Resize this image for social media posts. Keep everything intact: text, elements, colors — outpaint to fill the new aspect ratios. Don’t crop anything. I’m thinking: \n• LinkedIn post \n• Instagram post \n• YouTube cover \n\nLet me know if anything looks off.',
};

export const CONVERT_IMAGE_SUGGESTION: CanvasSuggestion = {
  icon: ConvertFileIcon,
  label: 'Convert to video',
  message:
    'Turn this image into a short video. Add a subtle motion effect — like a slow zoom or parallax — that feels cinematic, not cheesy. Keep it about 4 seconds.\n\nLet me know if you need more detail.',
};

export const IMAGE_SUGGESTIONS: CanvasSuggestion[] = [
  SMART_RESIZE_SUGGESTION,
  BUILD_CAMPAIGN_SUGGESTION,
  CONVERT_IMAGE_SUGGESTION,
];

export const EMPTY_CANVAS_SUGGESTIONS: CanvasSuggestion[] = [];
